module.exports = "<div #playerContainer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mprep/shared/lib/angular/components/flowplayer/renderers/normal/flowplayer-normal-renderer.html
// module id = k71c
// module chunks = 3